import React from "react";
import { useSelector } from "react-redux";
import { selectRegistrationAccountFormData } from "../../../../redux/slices/registrationAccountSlice";
import AccountForm from "../../../common/AccountForm";

const ConnectedAccountForm = () => {
    const formData = useSelector(selectRegistrationAccountFormData);
    const { formView } = formData;
    return <AccountForm formView={formView} />;
};

export default ConnectedAccountForm;
